import React, { Suspense } from "react";

export function withSuspense(Component: React.ComponentType): React.FC {
    const Result = (props: any) => {
        return (
            <Suspense>
                <Component {...props} />
            </Suspense>
        );
    }
    Result.displayName = `withSuspense(${Component.displayName})`;
    return Result;
}